<section class="laft-form--container">
  <div class="laft-form--header" *ngIf="currentStep === 1">
    <button class="laft-form--btn-close" (click)="save(true)">Guardar y salir</button>
  </div>
  <div *ngIf="currentStep > 1" class="laft-form--header laft-form--header-actions">
    <button class="laft-form--btn-back" (click)="previousStep()">
      <lib-icon icon="arrow_left" size="m" color="gradient-dark-blue"></lib-icon> Atrás
    </button>
    <button class="laft-form--btn-close" (click)="save(true)">Guardar y salir</button>
  </div>
  <app-laft-stepper class="laft-form--stepper" (submit)="onStepperSubmit($event)">
    <!-- Step 1 -->
    <app-laft-step>
      <app-laft-personal-data-form
        (formChangesEvent)="setFormData($event)"
        stepContent
        class="full"
        [userData]="data?.user"
        (nextStep)="onFormNextStep(2)"
        [initData]="data?.LAFTData"
      ></app-laft-personal-data-form>
    </app-laft-step>
    <!-- Step 2 -->
    <app-laft-step>
      <app-laft-pep-form
        (formChangesEvent)="setFormData($event)"
        stepContent
        class="full"
        (nextStep)="onFormNextStep(3)"
        [initData]="data?.LAFTData"
      ></app-laft-pep-form>
    </app-laft-step>
    <!-- Step 3 -->
    <app-laft-step>
      <app-laft-beneficiary-form
        (formChangesEvent)="setFormData($event)"
        stepContent
        class="full"
        (nextStep)="onFormNextStep(4)"
        [initData]="data?.LAFTData"
      ></app-laft-beneficiary-form>
    </app-laft-step>
    <!-- Step 4 -->
    <app-laft-step>
      <app-laft-investigation-form
        (formChangesEvent)="setFormData($event)"
        [initData]="data?.LAFTData"
        [isLastStep]="!isEarlyDepositEnabled"
        (nextStep)="onInvestigationNextStep()"
        stepContent
        class="full"
      ></app-laft-investigation-form>
    </app-laft-step>
    <!-- Step 5 -->
    <app-laft-step *ngIf="isEarlyDepositEnabled">
      <app-laft-id-copies-form
        (formChangesEvent)="setFormData($event)"
        [initData]="data?.LAFTData"
        [idType]="declaredIdType"
        [idNumber]="declaredIdNumber"
        stepContent
        class="full"
      ></app-laft-id-copies-form>
    </app-laft-step>
  </app-laft-stepper>
</section>
